
import { useCallback, useState } from "react";
import List from '../../grid.component';
import moment from "moment";

const operationIcons = {
    "fee": "fee-icon",
    "freeze": "freez-icon",
    "unfreeze": "unfreez-icon",
    "setpin": "setpin-icon",
    "bindcard": "bindcard-icon",
    "card creation": "card-creation-icon",
    "cancelled": "card-cancelled-icon",
    "top-up": "topup-icon",
    "refund": "refund-icon",
    "consumption": "consumption-icon",
    "first recharge": "firstrechanrge-icon",
    "signup": "card-creation-icon",
    "withdraw crypto": "firstrechanrge-icon",
    "consume": "consumption-icon",
    "authorized consumption": "consumption-icon",
    "deposite crypto": "firstrechanrge-icon",
    "card recharge": "firstrechanrge-icon",
};
export const DateHandler = ({ data }) => {
    return (
        <td>
            <div>
                {data?.date ? <> {moment.utc(data?.date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.date}
            </div>
        </td>
    )
}
//className="text-xs text-titleColor font-semibold
export const TemplateHandler = ({ data }) => {
    return (
        <td>
            <div>
                <div className="flex items-center gap-2">
                    <span className={`icon ${operationIcons[data?.action?.toLowerCase()] || "default-icon"} shrink-0`}></span>
                    <div>
                        <h4>
                            {data?.template || ""}
                        </h4>
                    </div>
                </div>
            </div>
        </td>
    )
}
const RecentActivities = () => {
    const [days, setDays] = useState(7);
    const getDays = useCallback((days) => {
        setDays(days);
    }, []);
    const dateHandler = useCallback((cellProps) => {
        return <DateHandler data={cellProps?.dataItem} />
    }, [])
    const templateHandler = useCallback((cellProps) => {
        return <TemplateHandler data={cellProps?.dataItem} />
    }, []);
    const customcells = {
        "date": dateHandler,
        "template": templateHandler,
        "address": dateHandler,
        "": templateHandler
    };
    const renderCustomCell = useCallback((props, column) => {
        if (customcells[column.field]) {
            return customcells[column.field](props);
        }
    }, [customcells]);
    return (
        <div>
            <div className="md:flex block items-start justify-between md:justify-end">
                <div className="range-buttons flex md:block border border-StrokeColor rounded-md">
                    <button
                        className={days === 7 ? "bg-primaryColor text-lightDark px-4 py-2 text-base rounded-l-md w-full md:w-auto" : "text-base text-subTextColor px-4 py-2 rounded-l-md w-full md:w-auto"}
                        onClick={() => getDays(7)}
                    >
                        7 Days
                    </button>

                    <button
                        className={days === 30 ? "bg-primaryColor text-lightDark px-4 py-2 text-base rounded-r-md w-full md:w-auto" : "text-base text-subTextColor px-4 py-2 rounded-l-md w-full md:w-auto"}
                        onClick={() => getDays(30)}
                    >
                        30 Days
                    </button>
                </div>
            </div>
            <div className="mt-4">
                <List
                    pSize={10}
                    className=""
                    screenName={'Dashboard_Activity'}
                    renderCustomCell={renderCustomCell}
                    style={{ maxHeight: "450px" }}
                    showDisplayColumns={false}
                    pageable={true}
                    filterable={false}
                    sortable={false}
                    additionalParams={{ "days": days }}
                    url={process.env.REACT_APP_API_END_POINT + `/api/CaseManagement/GetRecentActivityK`} />
            </div>
        </div>
    );
};

export default RecentActivities;
